module.exports = __webpack_public_path__ + "img/logo-northstar.1b9fcc5f.png";